import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';
import useGlobal from '../../../store/Store';
import { Results } from '../../../common/results/Results';
import { ClassificationResult } from '../../../common/results/ClassificationResult';
import { InferenceFile } from '../../../types';
import { Label } from '../../../types/label';
import { DatasetFileVersion } from '../../../types/dataset';
import { MultiflowIteratorResult, MultiflowStatus } from '../../../types/flow';
import axios from 'axios';
import { FlowPath } from '../../../components/FlowPath';
import { CustomSider } from '../../../components/layout/CustomSider';

type Props = {
  datasetFileVersion?: DatasetFileVersion;
  inferenceFile?: null | InferenceFile;
  onAnnotationChange: (labels: Label[]) => any;
  onClassChange: (className: string) => any;
  multiflowStatus?: null | MultiflowStatus;
};

const ResultSideBar = (props: Props) => {
  const { inferenceFile, onAnnotationChange, onClassChange, multiflowStatus } = props;

  const [globalState, globalActions] = useGlobal();
  const [multiIteratorResult, setMultiIteratorResult] = useState<null | MultiflowIteratorResult>(null);

  useEffect(() => {
    const fetchMultiIterator = async () => {
      if (multiflowStatus) {
        const { data } = await axios(multiflowStatus.iteratorResultUrl);
        const iteratorResult: MultiflowIteratorResult = data;
        setMultiIteratorResult(iteratorResult);
      }
    };
    fetchMultiIterator();
  }, [inferenceFile, multiflowStatus]);

  const onAccept = (label: Label) => {
    const labels = globalActions.acceptLabel(label);
    onAnnotationChange(labels);
  };

  const onDelete = (label: Label) => {
    const labels = globalActions.removeLabel(label);
    onAnnotationChange(labels);
  };

  const onEdit = (label: Label) => {
    if (globalState.labelEdit && globalState.labelEdit.id === label.id) {
      globalActions.setLabelEdit(null);
    } else {
      globalActions.setLabelEdit(label);
    }
  };

  const classification = inferenceFile && inferenceFile.annotations && inferenceFile.annotations.type;
  const isMultiflow =
    inferenceFile && inferenceFile.model && inferenceFile.model.algorithm && inferenceFile.model.algorithm.multiflow;

  return (
    <CustomSider width={400} border="left" style={{ paddingTop: '1.25rem' }}>
      <Row>
        <Col span={24}>
          {!isMultiflow && classification ? (
            <ClassificationResult
              result={classification}
              readOnly={globalState.readOnly}
              classes={
                (inferenceFile &&
                  inferenceFile.model &&
                  inferenceFile.model.info &&
                  inferenceFile.model.info.annotationTypes) ||
                []
              }
              onClassChange={onClassChange}
            />
          ) : (
            <Col>
              {isMultiflow && inferenceFile && (
                <FlowPath inferenceFile={inferenceFile} multiIteratorResult={multiIteratorResult} />
              )}
              <Results
                onAccept={onAccept}
                onDelete={onDelete}
                onEdit={onEdit}
                datasetMode={false}
                beautifyLabels={false}
                inTable={false}
              />
            </Col>
          )}
        </Col>
      </Row>
    </CustomSider>
  );
};

export default ResultSideBar;
